import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import toMoney, { buildDate, toPercentage } from "../../../../../utils";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InfoIcon from '@mui/icons-material/Info';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";

const RecurrentExpenseRowModel = {
    expense_id: 0,
    title: "",
    description: "",
    amount: 0,
    date_end: "",
    date_start: "",
    total_amount: 0,
    payed_amount: 0,
    count: 0,
    payed_count: 0,
    installments: [
        {
            date: "",
            payed: false
        }
    ]
}

export default function StatsActiveRecurrentExpensesRow({ expense = RecurrentExpenseRowModel, showTotalAmount = false }) {

    const [showDetailDialog, setShowDetailDialog] = useState(false);

    if (expense.expense_id === 0) {
        return <></>;
    }

    console.log(expense)

    return (
        <>
            <div
                className="stats-active-recurrent-expenses-row"
            >
                <div>{expense.title}</div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <div>
                        {
                            showTotalAmount ?
                                <>
                                    <div>Totale: </div>
                                    <div style={{ textAlign: "right" }}>{toMoney(expense.total_amount)}</div>
                                </>
                                :
                                <>
                                    <div>Rimanente: </div>
                                    <div style={{ textAlign: "right" }}>{toMoney(expense.total_amount - expense.payed_amount)}</div>
                                </>
                        }


                    </div>
                    <IconButton
                        onClick={() => setShowDetailDialog(true)}
                    >
                        <InfoIcon />
                    </IconButton>
                </div>
            </div>
            <Dialog
                open={showDetailDialog}
                onClose={() => setShowDetailDialog(false)}
                maxWidth="lg"
                fullWidth
                fullScreen
            >
                <DialogTitle>
                    <IconButton className='icon-size' onClick={() => setShowDetailDialog(false)} ><ArrowBackIcon /></IconButton> {expense.title}
                </DialogTitle>
                <DialogContent
                    sx={{
                        background: "#4169e1bf",
                        paddingTop: "1vh !important"
                    }}
                >
                    <div
                        className="summary-money-in-total-container"
                        style={{
                            paddingBottom: "0.5vh"
                        }}
                    >
                        <div className="summary-money-in-total-title" style={{ marginBottom: "1vh" }}>
                            Informazioni
                        </div>
                        <div className="stats-details-critical-categories-item-info-row">
                            <div className="">
                                <div className="stats-details-critical-categories-item-info-title">Rate Totali</div>
                                <div className="stats-details-critical-categories-item-info-content number">{expense.count}</div>
                            </div>
                            <div className="">
                                <div className="stats-details-critical-categories-item-info-title">Rate Pagate</div>
                                <div className="stats-details-critical-categories-item-info-content number">{expense.payed_count}</div>
                            </div>

                            <div className="">
                                <div className="stats-details-critical-categories-item-info-title">Rate Rimanenti</div>
                                <div className="stats-details-critical-categories-item-info-content number">{expense.count - expense.payed_count}</div>
                            </div>

                            <div className="">
                                <div className="stats-details-critical-categories-item-info-title">Importo Rata</div>
                                <div className="stats-details-critical-categories-item-info-content number">{toMoney(expense.amount)}</div>
                            </div>

                        </div>
                        <div className="stats-details-critical-categories-item-info-row">
                            <div className="">
                                <div className="stats-details-critical-categories-item-info-title">Importo Totale</div>
                                <div className="stats-details-critical-categories-item-info-content number">{toMoney(expense.total_amount)}</div>
                            </div>
                            <div className="">
                                <div className="stats-details-critical-categories-item-info-title">Importo Pagato</div>
                                <div className="stats-details-critical-categories-item-info-content number">{toMoney(expense.payed_amount)}</div>
                            </div>

                            <div className="">
                                <div className="stats-details-critical-categories-item-info-title">Importo Rimanente</div>
                                <div className="stats-details-critical-categories-item-info-content number">{toMoney(expense.total_amount - expense.payed_amount)}</div>
                            </div>

                        </div>
                        <div className="stats-details-critical-categories-item-info-row">

                            <div className="">
                                <div className="stats-details-critical-categories-item-info-title">% Completamento</div>
                                <div className="stats-details-critical-categories-item-info-content number">{toPercentage((expense.payed_count / expense.count) * 100)}%</div>
                            </div>

                            <div className="">
                                <div className="stats-details-critical-categories-item-info-title">Rata Iniziale</div>
                                <div className="stats-details-critical-categories-item-info-content number">{expense.date_start}</div>
                            </div>

                            <div className="">
                                <div className="stats-details-critical-categories-item-info-title">Rata Finale</div>
                                <div className="stats-details-critical-categories-item-info-content number">{expense.date_end}</div>
                            </div>

                        </div>
                    </div>
                    <div
                        className="summary-money-in-total-container"
                        style={{
                            paddingBottom: "0.5vh",
                            marginTop: "2vh"
                        }}
                    >
                        <div className="summary-money-in-total-title" style={{ marginBottom: "1vh" }}>
                            Dettagli
                        </div>
                        {
                            expense.installments.map((installment, index) => {
                                return (
                                    <div key={`installment-${expense.expense_id}-${index}`} className="stats-details-critical-categories-item-info-row">
                                        <div
                                            style={{
                                                width: "15%"
                                            }}
                                            className=""
                                        >
                                            <div className="stats-details-critical-categories-item-info-title">Rata</div>
                                            <div className="stats-details-critical-categories-item-info-content">{index + 1}</div>
                                        </div>
                                        <div
                                            style={{
                                                width: "60%"
                                            }}
                                            className=""
                                        >
                                            <div className="stats-details-critical-categories-item-info-title">Data</div>
                                            <div className="stats-details-critical-categories-item-info-content">{installment.date}</div>
                                        </div>

                                        <div
                                            style={{
                                                width: "15%"
                                            }}
                                            className=""
                                        >
                                            <div className="stats-details-critical-categories-item-info-title">Stato</div>
                                            <div className="stats-details-critical-categories-item-info-content">{installment.payed ? <DoneIcon color="success" /> : <CloseIcon color="warning" />}</div>
                                        </div>

                                    </div>
                                )
                            })
                        }
                    </div>
                    {/* {
                        expense.installments.map(installment => <div>{installment.date} {installment.payed}</div>)
                    } */}
                </DialogContent>
            </Dialog>
        </>

    )
}